import { isQrVisit, rememberQrToken } from './qrNavigation';

const pendingKey = 'orderpro_qr_pending_entry';
export const isQrEntryNonce = nonce => /^[a-f0-9]{48}$/.test(nonce || '');
export const pendingQrEntry = () => {
    const nonce = sessionStorage.getItem(pendingKey) || '';
    return isQrEntryNonce(nonce) ? nonce : '';
};
export const clearPendingQrEntry = nonce => {
    if (pendingQrEntry() === nonce) sessionStorage.removeItem(pendingKey);
};

export const prepareQrEntry = () => {
    const node = document.getElementById('orderpro-qr-entry');
    if (!node) return;
    let entry;
    try { entry = JSON.parse(node.textContent || '{}'); } catch (_) { return; }
    // The server emits a same-origin canonical Home path, never a redirect URL.
    if (!/^\/(?!\/)[a-zA-Z0-9_/-]*\/order$/.test(entry.path || '') && entry.path !== '/order') return;
    const previous = window.history.state || {};
    const state = { ...previous, usr: { ...previous.usr } };
    delete state.usr.orderproQrEntry;
    delete state.usr.orderproQrVisit;
    if (isQrEntryNonce(entry.entry)) {
        // Retrying or reloading a pending entry reuses its cookie-bound proof.
        sessionStorage.setItem(pendingKey, entry.entry);
        state.usr.orderproQrEntry = entry.entry;
    } else if (isQrVisit(entry.visit)) {
        rememberQrToken(entry.visit);
        sessionStorage.removeItem(pendingKey);
        state.usr.orderproQrVisit = entry.visit;
    } else return;
    window.history.replaceState(state, '', entry.path);
    node.remove();
};
